import styled from "@emotion/styled";

import React, { useEffect, useRef, useState } from "react";

type ToastMessageType = {
    message: string;
    setMessage: (message: string) => void;
    bottom: number;
};

const ToastMessage = ({ message, setMessage, bottom }: ToastMessageType) => {
    const [isLoad, setIsLoad] = useState(false);

    useEffect(() => {
        // 내용이 변경되면 애니메이션 재시작
        if (message !== "") {
            setIsLoad(false);
            setTimeout(() => setIsLoad(true), 10);
        }
    }, [message]);

    return (
        <Container $bottom={bottom}>
            {isLoad && (
                <Message
                    onAnimationEnd={() => {
                        setIsLoad(false);
                        setMessage("");
                    }}
                >
                    {message}
                </Message>
            )}
        </Container>
    );
};

export default ToastMessage;

const Message = styled.div`
    width: 100%;
    background: rgba(40, 40, 40, 0.7);
    font-size: 14px;
    line-height: 1.4;
    color: #fff;
    padding: 8px 14px;
    border-radius: 14px;
    animation: fadeInOut 3s forwards;

    @keyframes fadeInOut {
        0%,
        100% {
            transform: translateY(5px);
            opacity: 0;
        }
        10%,
        90% {
            transform: translateY(0);
            opacity: 1;
        }
    }
`;
// 86px
const Container = styled.div<{ $bottom: number }>`
    position: fixed;
    bottom: ${(props) => `${props.$bottom}px`};
    left: 14px;
    right: 14px;
    z-index: 9;
`;
